"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Section = function (_a) {
  var field = _a.field,
    fieldFactory = _a.fieldFactory;
  return react_1.default.createElement("fieldset", {
    className: field.model.cssClass
  }, field.fields.map(fieldFactory));
};
exports.default = Section;